(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfilePublicPositionDialogController', ProfilePublicPositionDialogController);

    ProfilePublicPositionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'Profile', 'Company', 'Collectivity', 'Principal'];

    function ProfilePublicPositionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, Profile, Company, Collectivity, Principal) {
        var vm = this;

        vm.profile = $stateParams.profile;
        vm.organizationsNoResults = false;
        vm.getOrganizations = getOrganizations;
        vm.clear = clear;
        vm.save = save;
        vm.addCurrentPosition = addCurrentPosition;
        vm.addPastPosition = addPastPosition;

        vm.profilesNoResults = false;
        vm.getProfiles = getProfiles;

        vm.isAdmin = isAdmin;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();

            if (vm.profile.positions){
                vm.currentPositions =  vm.profile.positions.filter(function(val) {
                    return val.active == true;
                });

                vm.pastPositions =  vm.profile.positions.filter(function(val) {
                    return val.active == false;
                });
            } else {
                vm.currentPositions = [];
                vm.pastPositions = [];
            }

        });

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function addCurrentPosition() {
            vm.currentPositions.push({"active":true});
        }

        function addPastPosition() {
            vm.pastPositions.push({"active":false});
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.profile.positions = vm.currentPositions.concat(vm.pastPositions);
            Profile.update(vm.profile, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:positionUpdate', result);
            $uibModalInstance.close(result);
            console.log(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getOrganizations(q) {
            return Company.search({ query: q }).$promise.then(function (companies) {
                return Collectivity.search({ query: q }).$promise.then(function (collectivities) {
                    var organizations = companies.concat(collectivities);
                    vm.organizationsNoResults = organizations.length === 0;

                    if (isAdmin()) {
                        organizations.map( function(org) {
                            if (org.equipeCommerciale) {
                                org.name = org.name + ' (' + org.equipeCommerciale.name+ ')'
                            }
                        });
                    }
                    return organizations;
                });
            });
        }

        function getProfiles(q) {
            return Profile.search({ query: q }).$promise.then(function (profiles) {
                vm.profilesNoResults = profiles.length === 0;
                return profiles;
            });
        }

    }
})();
